var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseStroke24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 10.9514L18.9698 3.97101C19.3286 3.61216 19.9153 3.61582 20.2813 3.96826C20.6564 4.32954 20.6379 4.93104 20.284 5.28499L13.3033 12.2656L20.284 19.2463C20.6409 19.6033 20.6414 20.1908 20.2852 20.5483C19.9276 20.9182 19.3263 20.9182 18.9686 20.5484L11.9998 13.5796L5.02055 20.5484C4.66142 20.9197 4.07277 20.9158 3.70651 20.5509C3.33275 20.1895 3.35173 19.5998 3.70521 19.2463L10.6859 12.2656L3.70521 5.28499C3.34637 4.92615 3.35013 4.33958 3.70257 3.97359C4.06385 3.59842 4.66536 3.61695 5.0193 3.9709L11.9998 10.9514Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseStroke24);
export default __webpack_public_path__ + "static/media/Close_Stroke_24.4c560beee98649f32a36f29f39c0859b.svg";
export { ForwardRef as ReactComponent };